var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "48 Warning"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd54f",
    d: "M29.764 23.453 18.576 5.52a3.027 3.027 0 0 0-5.146-.009L2.224 23.474A3.027 3.027 0 0 0 4.807 28h22.386a3.028 3.028 0 0 0 2.571-4.547z",
    opacity: 1,
    "data-original": "#ffd54f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596c76",
    d: "m15.087 18.624-.266-3.976c-.052-.8-.325-2.093.286-2.743.465-.5 1.566-.586 1.9.107a4.873 4.873 0 0 1 .182 2.536l-.356 4.093a3.221 3.221 0 0 1-.249 1.12.708.708 0 0 1-1.254.013 3.763 3.763 0 0 1-.243-1.15zm.921 5.463a1.24 1.24 0 0 1-.142-2.471 1.24 1.24 0 1 1 .142 2.471z",
    opacity: 1,
    "data-original": "#596c76",
    className: ""
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9f396dcf56fca7e7430bd20f256fa742.svg";
export { ForwardRef as ReactComponent };